/// <reference types="vite/client" />
import { createClient } from "@supabase/supabase-js";

// .env ファイルから URL と APIキーを取得
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Supabase URLまたはAPIキーが設定されていません");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
